import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rateLoading: false,
  isLoading: true,
  error: "",
  MyCourses: [],
  singleCourseInfo: {},
  singleLessonInfo: {},
};

export const PartnersCoursesSlice = createSlice({
  name: "partnerCourses",
  initialState,
  reducers: {
    genericSetData: (state, action) => {
      const { keyName, keyValue } = action.payload;
      state[keyName] = keyValue;
    },
    openLoader: (state) => {
      state.rateLoading = true;
    },
    closeLoader: (state) => {
      state.rateLoading = false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearData: (state) => {
      state.error = "";
      state.MyCourses = [];
      state.singleCourseInfo = {};
      state.singleLessonInfo = {};
    },
  },
});

export const {
  genericSetData,
  openLoader,
  closeLoader,
  setError,
  setLoading,
  clearData,
} = PartnersCoursesSlice.actions;
export default PartnersCoursesSlice.reducer;
